import GrammarDescriptionFlag from 'components/grammar_description_flag';
import styled from '@emotion/styled';
import { Constants } from '@seedlang/constants';
import { CaseIcon } from '@seedlang/icons';
import { isBlank, isPresent } from '@seedlang/utils';
import Spinner from 'components/spinner';
import Text from 'components/text';
import TextDisplay from 'components/text_display';
import { observer } from 'mobx-react';
import React from 'react';

const Wrapper = styled.div`
  text-align: left;
  font-size: 16px;
  line-height: 22px;
  padding: 20px 20px 50px 20px;
  .close-icon {
    width: ${props => props.minimized ? '22' : '30'}px;
  }
  h3 {
    border-bottom: 1px solid gray;
    font-size: 18px;
    width: 100%;
  }
  table {
    .header-row {
      td {
        background: #777;
        color: white;
        font-size: 12px;
        font-weight: bold;
        padding: 5px 10px;
      }
    }
  }
  .info-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 4px;
    }
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  border-bottom: 1px solid gray;
  width: 100%;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
`;

@observer
class ConceptDescription extends React.Component {

  render() {
    if (isBlank(this.props.concept)) {
      return (
        <Wrapper>
          <SpinnerWrapper>
            <Spinner />
          </SpinnerWrapper>
        </Wrapper>
      );
    }
    return (
      <Wrapper>
        <TitleWrapper>
          {
            isPresent(this.props.concept.grammarCase) && this.props.concept.grammarCase !== 'none' &&
              <CaseIcon case={Constants.CASES.find(item => item.abbreviation === this.props.concept.grammarCase).slug} />
          }
          <Text heading='3'>
            {this.props.concept.displayNameLine1}
          </Text>
        </TitleWrapper>
        {
          this.props.concept.displayNameLine2 &&
            <Text italic fontSize='14px'>{this.props.concept.displayNameLine2}</Text>
        }
        {
          isPresent(this.props.concept?.longDescription) &&
            <>
              <TextDisplay
                htmlText={this.props.concept?.longDescription}
              />
              <GrammarDescriptionFlag key={this.props.concept?.id} conceptId={this.props.concept?.id} languageId={this.props.concept?.grammarDescriptionLanguageId} />
            </>
        }
      </Wrapper>
    );
  }
}

export default ConceptDescription;